import React from 'react'
import SideNav from 'components/sidenav/Sidenav'
import {
  Wrapper,
  Header,
  Body,
  Footer,
  SideContainer,
  SidePanel,
  MarginTop
} from './styles'
import Form from '1.newComponents/form'
import cashAdvancesConfig from '0.componentConfigs/2.cashAdvances'

function CashAdvance ({ config }) {
  return (
    <>
      <SideContainer>
        <SidePanel>
          <SideNav />
        </SidePanel>
      </SideContainer>
      <Wrapper>
        <Header>{config.requestType}</Header>
        <Body>
          <Form config={config} />
        </Body>
        <Footer />
      </Wrapper>
    </>
  )
}

export default CashAdvance
